export default "__VITE_ASSET__6dKH8CzC__"